import type { FC } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ScarcityLabel } from './ScarcityLabel';

interface OnlyXLeftLabelProps {
    quantityLeft: number;
}

export const OnlyXLeftLabel: FC<OnlyXLeftLabelProps> = ({ quantityLeft }) => (
    <ScarcityLabel id="scarcity-label-only-x-left-label">
        <FormattedMessage
            id="scarcity.label.only.x.left"
            defaultMessage="Only {quantityLeft} left"
            values={{ quantityLeft }}
        />
    </ScarcityLabel>
);

OnlyXLeftLabel.propTypes = {
    quantityLeft: PropTypes.number.isRequired,
};
